import { Link } from 'react-router-dom';
import { ProjectModel, ShowModel } from '../../../network/rest';
import './style.scss';

interface Props {
    data: ShowModel | ProjectModel;
    url: string;
}

function ListItemWithoutDescription({ data, url }: Props) {
    const { title, id } = data;
    return (
        <Link to={`${url}/${id}`} className="ListItemWithoutDescription">
            <div className="image-wrapper">
                {data.fileUrl && <img src={data.fileUrl as unknown as string} alt={data.title} />}
            </div>
            <div className="show-info">
                <h2>{title}</h2>
            </div>
        </Link>
    );
}

export default ListItemWithoutDescription;
